import { ModalWrapper } from '../ModalWrapper';
import PortalModal from '../PortalModal/PortalModal';

interface Props {
  text: string;
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
  submitHandler: () => void;
  t: any;
}

const ConfirmDialog: React.FC<Props> = ({
  text,
  isOpen,
  setIsOpen,
  submitHandler,
  t,
}) => {
  return (
    <PortalModal isOpen={isOpen} setIsOpen={setIsOpen}>
      <ModalWrapper submitHandler={submitHandler} setIsOpen={setIsOpen} t={t}>
        <p className="text-body1">{text}</p>
      </ModalWrapper>
    </PortalModal>
  );
};

export default ConfirmDialog;
